// @ts-check
import { Link } from '@material-ui/core';
import * as LighthouseService from 'common/services/lighthouse.service';
import teamGoalsEmptyState from 'images/characters/teamGoals-emptyState.svg';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { LBButton } from '@linearb/buzz';

const TeamGoalsEmptyState = ({
  history,
  selectTeamId,
  globallySelectedTeamId
}) => {
  return (
    <Flex
      items='center'
      justify='center'
      direction='column'
      width='100%'
      pt='medium'
    >
      <img
        src={teamGoalsEmptyState}
        alt=''
        style={{ width: '30rem', height: '38rem' }}
      />
      <Flex pb='small'>
        <Text size='medium' color='shuttleGray' pr='0.3rem'>
          Set up Team Goals, start building towards your goals right now!
        </Text>
        <Text size='medium'>
          <Link onClick={() => LighthouseService.navigateArticle('93hjd4drzc')}>
            Learn more
          </Link>
        </Text>
      </Flex>

      <LBButton
        size='lg'
        onClick={() => {
          selectTeamId(globallySelectedTeamId);
          history.push({
            pathname: '/settings/notifications'
          });
        }}
      >
        Team Goals Settings
      </LBButton>
    </Flex>
  );
};

export default TeamGoalsEmptyState;
